// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ei-alleviivausta[data-v-3adb33ef] {\n  text-decoration: none;\n}", ""]);
// Exports
module.exports = exports;
